import { useEffect, useRef } from "react";

/**
 * Calls `onOutside` on a mousedown/touch outside `ref`, or when Escape is pressed.
 * Only listens while `enabled` is true.
 */
export function useClickOutside(ref, onOutside, enabled = true) {
  const handlerRef = useRef(onOutside);
  handlerRef.current = onOutside;

  useEffect(() => {
    if (!enabled) return undefined;

    const handlePointer = (e) => {
      if (ref.current && !ref.current.contains(e.target)) handlerRef.current?.(e);
    };
    const handleKey = (e) => {
      if (e.key === "Escape") handlerRef.current?.(e);
    };

    document.addEventListener("mousedown", handlePointer);
    document.addEventListener("touchstart", handlePointer);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handlePointer);
      document.removeEventListener("touchstart", handlePointer);
      document.removeEventListener("keydown", handleKey);
    };
  }, [ref, enabled]);
}
